import React from "react";
import { getUpdatedState } from "../state/updatedState";
import { MailingServiceQuantities, MerchandisingProductView } from "../types/ContentfulTypes";
import { AttributeConstraint } from "../types/ConstraintsTypes";
import { LowestPrice } from "@vp/hamilton-service-clients/dist/src/types/Pricing";

export const isMailingServicesMpv = (mpvId: string, locale: string): boolean => {
  return (
    (locale?.toLowerCase() === "en-us" || locale?.toLowerCase() === "es-us") &&
    mpvId === "mailingServicesPostcard"
  );
};

export const mailingServiceQuantityValues = [
  1,
  50,
  100,
  250,
  500,
  750,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  5000,
  6000,
  7000,
  8000,
  9000,
  10000,
  15000,
  20000,
];

export const mailingServiceQuantities: MailingServiceQuantities = {
  quantities: mailingServiceQuantityValues,
  default: mailingServiceQuantityValues[0],
};

// TODO This map is eventually gonna be provided by some service. Remove this hardcode when the service is ready.
const mailingServicesMpvMap: Record<string, string> = {
  postcards: "mailingServicesPostcard",
};

export const mapToMailingServicesMpv = (mpvId: string, locale: string): string | undefined => {
  if (locale?.toLowerCase() === "en-us" || locale?.toLowerCase() === "es-us") {
    return mailingServicesMpvMap[`${mpvId}`];
  }
  return undefined;
};

export const getMailingServiceCompatibilityAndPricing = (props: {
  mpv: MerchandisingProductView;
  locale: string;
  selections: Record<string, string>;
  selectedQuantity: number;
  pricingContext?: string;
}) => {
  const { mpv, locale, selections, pricingContext, selectedQuantity } = props;

  const [attributeConstraints, setAttributeConstraints] = React.useState<AttributeConstraint[]>([]);
  const [compatibleQuantities, setCompatibleQuantities] = React.useState<number[]>([]);
  const [compatibleValues, setCompatibleValues] = React.useState<Record<string, string[]>>({});
  const [prices, setPrices] = React.useState<Record<number, LowestPrice>>({});
  const [showSelectionLoader, setShowSelectionLoader] = React.useState<boolean>(false);

  React.useEffect(() => {
    const callUpdateState = async () => {
      const updateStatePromise = getUpdatedState({
        locale,
        selections,
        mpv,
        pricingContext,
        selectedQuantity,
        currentCompatibleValues: {},
        currentCompatibleRanges: {},
      });
      setShowSelectionLoader(true);

      const {
        attributeConstraints,
        compatibleQuantities,
        compatibleValues,
        prices,
      } = await updateStatePromise;
      setShowSelectionLoader(false);

      setAttributeConstraints(attributeConstraints || []);
      setCompatibleQuantities(compatibleQuantities);
      setCompatibleValues(compatibleValues);
      setPrices(prices);
    };

    callUpdateState();
  }, [mpv, locale, selections, pricingContext, selectedQuantity]);

  return {
    attributeConstraints,
    compatibleQuantities,
    compatibleValues,
    prices,
    showSelectionLoader,
  };
};
